import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import {
    Row,
    Card,
    Form,
    DatePicker,
    Button,
    Input,
    Modal,
    Select,
    Tooltip,
    Table,
    Col,
    Divider,
    Spin
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { FolderOpenOutlined, EditOutlined } from "@ant-design/icons";

//OTHER IMPORTS
import dayjs from 'dayjs';

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import CustomButton from "../../../../components/custom/CustomButton";
import MainLayout from "../../../../components/layouts/MainLayout";
import TopContent from "../../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../group.config";
import { accountStatus } from "../../../../components/facilities/AccountFacility";
import styles from "../../../../assets/styles/styles";
import { log } from "@antv/g2plot/lib/utils";


const AttachMeeting = (props) => {
    const { userData } = props;
    const { session } = userData;
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const { state } = useLocation();
    const [isRepeating, setIsRepeating] = useState(false);
    const [isRepeatWeekly, setIsRepeatWeekly] = useState(false);
    const [repeatsOptions, setRepeatsOptions] = useState([]);
    const [repeatingDaysOptions, setRepeatingDaysOptions] = useState([]);
    const [repeatsEveryData, setRepeatsEveryData] = useState([]);
    const [templateDetails, setTemplateDetails] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const dateFormat = 'YYYY/MM/DD';


    useEffect(() => {
        getTemplate();
    }, []);

    const getTemplate = () => {

        const url = `${apiConfig.Groups}/${state.id}/calendars/template`;

        let body = {
            session,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
                setIsLoading(false);
            } else {
                const objDetail = res;
                setTemplateDetails(res);
                let tempRepeatsOptions = [];
                let tempRepeatingDaysOptions = [];

                objDetail?.frequencyOptions.forEach(element => {
                    tempRepeatsOptions.push({
                        value: element?.id,
                        label: element?.value
                    })
                });

                objDetail?.repeatsOnDayOptions.forEach(element => {
                    tempRepeatingDaysOptions.push({
                        value: element?.id,
                        label: element?.value
                    })
                });

                form.setFieldsValue({
                    frequency: objDetail?.frequencyOptions[0].id,
                    interval: staticConfig.attachMeetDailyYearlyRepeats[0].value
                })
                setRepeatsEveryData(staticConfig.attachMeetDailyYearlyRepeats)
                setRepeatsOptions(tempRepeatsOptions);
                setRepeatingDaysOptions(tempRepeatingDaysOptions)
                setIsLoading(false);
            }
        });
    };

    function onCancel() {
        navigate("/detail-group", { state: state });
    };

    const onChangeRepeat = (value) => {
        setIsRepeating(value)
    };

    const handleRepeatsChange = (value, option) => {
        switch (option?.label.toLowerCase()) {
            case "daily":
                setIsRepeatWeekly(false)
                setRepeatsEveryData(staticConfig.attachMeetDailyYearlyRepeats)
                break;
            case "weekly":
                setIsRepeatWeekly(true);
                setRepeatsEveryData(staticConfig.attachMeetingWeeklyRepeats)
                break;
            case "monthly":
                setIsRepeatWeekly(false)
                setRepeatsEveryData(staticConfig.attachMeetingMonthlyRepeats)
                break;
            case "yearly":
                setIsRepeatWeekly(false)
                setRepeatsEveryData(staticConfig.attachMeetDailyYearlyRepeats)
                break;
            default:
                setIsRepeatWeekly(false)
                break;
        }
    };

    const onSubmit = (formValues) => {
        const url = `${apiConfig.Groups}/${state.id}/calendars`;

        formValues.startDate = BOM.DateTime(formValues?.startDate, "only-date");
        formValues.title = `groups_${state.id}_CollectionMeeting`;
        formValues.typeId = templateDetails?.type?.id;

        const body = {
            ...formValues,
            dateFormat: "dd MMMM yyyy",
            locale: "en",
            method: "POST",
            session,
        };

        setIsLoading(true);
        BOM.FetchReqAction(body, url, (err, res) => {
            if (err) {
                BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
                setIsLoading(false);
            } else {
                BOM.AlertMsg(cnt.SUCCESS, labelConfig.grpAttendanceMsg);
                navigate("/detail-group", {
                    state: { ...state, statusValue: accountStatus.active },
                });
                //STOP LOAD
                setIsLoading(false);
            }
        });
    };

    return (
        <MainLayout isEnableRightSidebar={true}>
            {/* PART 1  IMPORT TOP CONTENT*/}
            <TopContent
                pageTitle={labelConfig.attachMeeting}
                pageItems={staticConfig.grpAttachMeetingBreadcrumbItems}
            />

            <Spin spinning={isLoading} size="large">
                <Card
                    headStyle={{ borderBottomWidth: 0 }}
                    style={{
                        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
                        borderRadius: 20,
                    }}
                >
                    <Form form={form} layout="vertical" onFinish={onSubmit}>
                        <Row>
                            <Divider orientation="left">{`Account No: ${state.accountNo}`}</Divider>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label="Meeting Start Date"
                                    name="startDate"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.date),
                                        },
                                    ]}
                                >
                                    <DatePicker
                                        style={{ width: "100%", height: 35 }}
                                        format={dateFormat}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8} style={{ padding: "0px 8px" }}>
                                <Form.Item
                                    label={labelConfig.repeat}
                                    name="repeating"
                                    rules={[
                                        {
                                            required: true,
                                            message: BOM.CheckReqFld(labelConfig.repeat),
                                        },
                                    ]}
                                >
                                    <Select
                                        filterOption={(input, option) =>
                                            (option?.label?.toLowerCase() ?? "").includes(
                                                input?.toLowerCase()
                                            )
                                        }
                                        placeholder={BOM.handlePlaceholderMsg(
                                            labelConfig.repeat,
                                            "select"
                                        )}
                                        options={staticConfig.yesOrNo}
                                        showSearch
                                        onChange={onChangeRepeat}
                                    />
                                </Form.Item>
                            </Col>
                            {
                                isRepeating &&
                                <>
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.repeats}
                                            name="frequency"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: BOM.CheckReqFld(labelConfig.repeats),
                                                },
                                            ]}
                                        >
                                            <Select
                                                filterOption={(input, option) =>
                                                    (option?.label?.toLowerCase() ?? "").includes(
                                                        input?.toLowerCase()
                                                    )
                                                }
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.repeats,
                                                    "select"
                                                )}
                                                options={repeatsOptions}
                                                showSearch
                                                onChange={handleRepeatsChange}
                                            />
                                        </Form.Item>
                                    </Col>
                                    {
                                        isRepeatWeekly &&
                                        <Col span={8} style={{ padding: "0px 8px" }}>
                                            <Form.Item
                                                label={labelConfig.repeatingDays}
                                                name="repeatsOnDay"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: BOM.CheckReqFld(labelConfig.repeatingDays),
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    filterOption={(input, option) =>
                                                        (option?.label?.toLowerCase() ?? "").includes(
                                                            input?.toLowerCase()
                                                        )
                                                    }
                                                    placeholder={BOM.handlePlaceholderMsg(
                                                        labelConfig.repeatingDays,
                                                        "select"
                                                    )}
                                                    options={repeatingDaysOptions}
                                                    showSearch
                                                />
                                            </Form.Item>
                                        </Col>
                                    }
                                    <Col span={8} style={{ padding: "0px 8px" }}>
                                        <Form.Item
                                            label={labelConfig.repeatsEvery}
                                            name="interval"
                                            rules={[
                                                {
                                                    required: true,
                                                    message: BOM.CheckReqFld(labelConfig.repeatsEvery),
                                                },
                                            ]}
                                        >
                                            <Select
                                                filterOption={(input, option) =>
                                                    (option?.label?.toLowerCase() ?? "").includes(
                                                        input?.toLowerCase()
                                                    )
                                                }
                                                placeholder={BOM.handlePlaceholderMsg(
                                                    labelConfig.repeatsEvery,
                                                    "select"
                                                )}
                                                options={repeatsEveryData}
                                                showSearch
                                                onChange={onChangeRepeat}
                                            />
                                        </Form.Item>
                                    </Col>
                                </>
                            }
                        </Row>
                        <Row>
                            <Divider />
                            {BOM.HasPermission("CREATE_MEETING") &&
                                <CustomButton
                                    content="Submit"
                                    style={{
                                        width: "10%",
                                        marginLeft: "auto",
                                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                    }}
                                    htmlType="submit"
                                    backgroundColor="#15CCAE"
                                    colorText="black"
                                    hoverBackground="#4FECA0"
                                />}

                            <CustomButton
                                content="Cancel"
                                style={{
                                    width: "10%",
                                    marginLeft: "1%",
                                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                                }}
                                backgroundColor="#fff"
                                colorText="black"
                                hoverBackground="#F5F5F5"
                                onClick={onCancel}
                            />
                        </Row>
                    </Form>
                </Card>
            </Spin>
        </MainLayout>
    );
};
export default AttachMeeting;

